/**
 * 个人文档样例模板(2026-09-07 老板拍板「引导不设卡」三件套之一)。
 *
 * 为什么给模板而不是限格式:解析器对**问答对**有专门的切块与检索快路,命中率天然最高,
 * 而个人库的典型用法(自己的话术/客户 FAQ/经验速记)恰好是问答形态。模板是把这条
 * 高命中路摆到用户手边,不挡任何随手上传。纯前端静态内容,零后端依赖。
 */
import { triggerDownload } from "@/shared/lib/download";

export interface PersonalDocTemplate {
  /** 下载文件名(.md)。 */
  filename: string;
  /** 按钮上的短名。 */
  label: string;
  content: string;
}

export const PERSONAL_DOC_TEMPLATES: PersonalDocTemplate[] = [
  {
    filename: "问答速记模板.md",
    label: "问答速记模板",
    // Q:/A: 问答对是解析器识别的结构(逐对切块,检索命中最准)。答案可多行,空行分隔下一对。
    content: `# 我的问答速记

Q: 客户问敏感肌能不能用我们的精华?
A: 可以。主打成分是神经酰胺+积雪草,无酒精无香精,敏感肌实测 28 天无刺激报告可以发给客户。

Q: 客户嫌贵怎么回?
A: 先认可预算顾虑,再拆到每天成本(一瓶用 3 个月,每天不到 3 块钱),最后给试用装方案降低门槛。

Q: 售后退换的口径?
A: 未拆封 7 天无理由;拆封后有质量问题拍照走客服通道,48 小时内处理。
`,
  },
  {
    filename: "通用速记模板.md",
    label: "通用速记模板",
    // 通用版:标题分节 + 短段落/要点,解析器按节切块;提醒别整篇糊成一段。
    content: `# 我的工作速记

## 客户偏好
- 张总(华东经销):只看数据,汇报先给转化率;微信别发语音。
- 李姐(老客):对价格敏感,活动期第一时间通知。

## 常用话术
开场先问最近的经营痛点,再带到方案;不要一上来就报价。

## 经验教训
换季期客诉集中在物流,提前三天备好话术与补偿方案。
`,
  },
];

/** 生成 .md 文件并触发浏览器下载(Blob URL 用完即回收)。 */
export function downloadPersonalDocTemplate(tpl: PersonalDocTemplate): void {
  const blob = new Blob([tpl.content], { type: "text/markdown;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  try {
    triggerDownload(url, tpl.filename);
  } finally {
    // 下载由浏览器接管后 URL 即可回收;延迟一拍防个别浏览器取流未完成。
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
  }
}
